import http from "../clients/http";
import httpClient from "../clients/http";
import { serializeParams } from "../utils/url";
import { ProductImportJob } from "../types/product-import-job";

type ProductGetListParams = {
  status: string | null;
  search: string | null;
  page: string | null;
  size: string | null;
  sort?: string | null;
  category?: string | null;
};

type INewProductForm = any;

export class ProductService {
  static async create(formData: INewProductForm): Promise<unknown> {
    const response = await http.post(`/products`, {
      name: formData.name,
      description: formData.description,
      price: Number(formData.gross),
      initialStock: Number(formData.initialStock),
      status: formData.status,
      category: { id: formData.category.value },
      code: formData.code,
      mediaAssets: formData.mediaAssets,
      cost: formData.cost,
      attributes: formData.attributes,
    });

    if (!(response.status < 299)) throw Error();

    return response.data;
  }

  static async update(id: string, formData: INewProductForm) {
    const response = await http.put(`/products/${id}`, formData);
    return response.data;
  }

  static async getList(filters: Partial<ProductGetListParams>) {
    const response = await http.get(`/products?${serializeParams(filters)}`);
    const { data } = response;

    return {
      data: data.data,
      pagination: data.pagination,
    };
  }

  static async getDetails(id: string) {
    const response = await http.get(`/products/${id}`);
    const { data } = response;
    return data;
  }

  static async getSales(id: string) {
    const response = await httpClient.get(`/products/${id}/sales`);
    return response.data;
  }

  static async getInventory(id: string, filters: ProductGetListParams) {
    const response = await httpClient.get(`/products/${id}/inventory`);
    return response.data;
  }

  static async getSalesStats(id: string) {
    const response = await httpClient.get(`/products/${id}/sales/stats`);
    return response.data;
  }

  static delete(id: string): any {
    return httpClient.delete(`products/${id}`);
  }

  static async changeStatus(id: string, status: string): Promise<any> {
    const response = await httpClient.put(`/products/${id}/status`, { status });
    return response.data;
  }

  static async import(
    file: File,
    updateIfExists: boolean,
    publishProducts: boolean,
    categoryStrategy: "create" | "skip",
  ): Promise<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("updateIfExists", String(updateIfExists));
    formData.append("publishProducts", String(publishProducts));
    formData.append("categoryStrategy", categoryStrategy);
    const response = await http.post(`/products/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  static async getImportJob(id: string): Promise<any> {
    const response = await http.get(`/products/import/${id}`);
    return response.data;
  }
}

export function downloadImportTemplate() {
  return http.get("/products/import/template", {
    responseType: "blob",
  });
}
